import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';
import type {
	MyUser,
	Profile,
	SubLabel,
	User,
} from '@deezer/next/contexts/main/types';
import type {UserSetting} from '@deezer/next/services/types/userSettings';
import type {FeatureLabel} from '@deezer/next/services/types/features';
import type {UserForm} from '@deezer/next/features/Account/type';

const {get, post, patch} = requestWrapper;

const requests = {
	sendPasswordResetRequest: (email: string) =>
		post<DataResponseWrapper<'Email sent'>>(endpoints.passwordReset, {email}),
	validatePasswordResetToken: (token: string) =>
		get<DataResponseWrapper<'ok'>>(endpoints.passwordReset, {
			params: {
				token,
			},
		}),
	updatePassword: (password: string, token: string) =>
		patch<DataResponseWrapper<'ok'>>(
			endpoints.passwordUpdate,
			{password},
			{params: {token}},
		),
	getMe: () => get<DataResponseWrapper<MyUser>>(endpoints.me),
	getSubLabels: ({
		includeDisabledProviders,
	}: {
		includeDisabledProviders?: boolean;
	}) =>
		get<DataResponseWrapper<SubLabel[]>>(endpoints.subLabels, {
			params: {
				include_disabled_providers: includeDisabledProviders ? 1 : 0,
			},
		}),
	getUser: (id: string) =>
		get<DataResponseWrapper<User>>(endpoints.userById(id)),
	getCollaborators: () =>
		get<DataResponseWrapper<User[]>>(endpoints.collaborators),
	getMyProfiles: () =>
		get<DataResponseWrapper<Profile[]>>(endpoints.myProfiles),

	createUser: (data: UserForm) =>
		post<DataResponseWrapper<any>>(endpoints.create, data),
	patchUser: (id: string, data: UserForm) =>
		patch<DataResponseWrapper<any>>(endpoints.userById(id), data),
	deleteUser: (id: string) =>
		requestWrapper.delete<DataResponseWrapper<any>>(endpoints.userById(id)),
	deleteSubLabel: (labelId: number) =>
		requestWrapper.delete<DataResponseWrapper<{message: string}>>(
			endpoints.subLabelById(labelId),
		),
	postSetting: <K extends FeatureLabel | 'user'>(
		key: K,
		settings: UserSetting<K>,
	) =>
		post<DataResponseWrapper<{message: string}>>(endpoints.settings, {
			feature: key,
			settings,
		}),
	deleteSettings: (key: FeatureLabel) =>
		requestWrapper.delete<DataResponseWrapper<{message: string}>>(
			endpoints.settings,
			{
				feature: key,
			},
		),
};

export default requests;
